import { compareStrings } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../gridComponents/grid-config';
import { EncryptionExclusionItem } from '@nirvana/shared/dtos/types/policies/common';
import { getLabelByExclusionItemType } from '../../../../utils/uiSettings/encryption/encryption.values';

// sort by column type
export function sortByColumn(
  item1: EncryptionExclusionItem,
  item2: EncryptionExclusionItem,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(
        getLabelByExclusionItemType(item1.type),
        getLabelByExclusionItemType(item2.type),
        direction
      );

    case ColumnKeys.ENTITY:
      return compareStrings(item1.entity, item2.entity, direction);
  }

  return 0;
}
